var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
    'text-white font-header leading-5 border-0 rounded-lg transition duration-200 focus:outline-none text-base py-2 px-4',
    _vm.buttonColor ],on:{"click":function($event){return _vm.$emit('on-click')}}},[_c('i',{class:['fas mr-2', _vm.icon || 'hidden']}),_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }